module.exports = __webpack_public_path__ + "files/6b0f75d756e5aae2bb49aaabacfb4900.png";